var exports = {
  "W": "xe533113f--ab5833--labels",
};

module.exports = exports;
